import type { CSSProperties, ReactNode } from 'react'

// `left`/`center`/`right` share the bar; `below` is a second row beneath it
export type MiniNotchSlot = 'left' | 'center' | 'right' | 'below'

export interface MiniNotchItem {
  id: string
  slot: MiniNotchSlot
  show: boolean
  node: ReactNode
  className?: string
  style?: CSSProperties
  /** Skips the position animation, for an item pinned by its outer edge whose width changes. */
  holdsPosition?: boolean
  /** Its node runs its own entrance, so the slot only animates it out. */
  hasOwnEntrance?: boolean
  /** A `below` item that is laid out at a fixed width, which the cutout grows to hold. */
  width?: number
  /** A `below` item's bottom corner, for content whose own corners the cutout should run parallel to. */
  cornerRadius?: number
}

export type MiniNotchItemGroups = Record<MiniNotchSlot, Array<MiniNotchItem>>

export function groupMiniNotchItems(items: Array<MiniNotchItem>): MiniNotchItemGroups {
  const groups: MiniNotchItemGroups = {
    left: [],
    center: [],
    right: [],
    below: [],
  }

  for (const item of items) {
    if (item.show) {
      groups[item.slot].push(item)
    }
  }

  return groups
}
